// extracted by mini-css-extract-plugin
export default {"overlay":"PopupBookmark_overlay__wK4eJ","wrapper":"PopupBookmark_wrapper__jWn0N","buttonClose":"PopupBookmark_buttonClose__y7kPF"};